// ABOUTME: SPEC-92 D-4/D-5 — the one additive key a gesture-made interaction carries: `gesture: 'wheel' | 'touch'`.
// ABOUTME: Pure. Anything that is not exactly a gesture input leaves the caller's `extra` untouched (same reference).

// The inputs the gesture gate reports (useReelSwipeNav's attachWheel / attachTouch). A whitelist, not a truthiness test:
// a Views button's onPress also receives a click event or nothing at all, and those frames must stay byte-identical.
export const GESTURE_INPUTS = Object.freeze(['wheel', 'touch']);

/**
 * `extra` with `gesture: via` added when `via` is a gesture input, else `extra` itself (same reference, so a tap, a menu
 * entry or a voice move sends exactly the frame it sent before). Never mutates `extra`; `null` extra becomes `{ gesture }`.
 */
export function withGesture(extra, via) {
  if (!GESTURE_INPUTS.includes(via)) return extra;
  return { ...(extra || {}), gesture: via };
}
